import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const tocItems = [
  { id: 'critique', labelKey: 'toc_critique' },
  { id: 'criteres', labelKey: 'toc_10' },
  { id: 'questions', labelKey: 'toc_questions' },
  { id: 'alarmes', labelKey: 'toc_alarmes' },
  { id: 'soumission', labelKey: 'toc_soumission' },
  { id: 'verif', labelKey: 'toc_verif' },
  { id: 'faq', labelKey: 'toc_faq' },
];

export default function TableMatieres() {
  const { t } = useTranslation('blogchoisir');
  const [isOpen, setIsOpen] = useState(false);
  const [activeId, setActiveId] = useState('');

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveId(entry.target.id);
          }
        });
      },
      { rootMargin: '-100px 0px -60% 0px' }
    );

    tocItems.forEach((item) => {
      const el = document.getElementById(item.id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsOpen(false);
    }
  };

  return (
    <>
      {/* Mobile accordion */}
      <div className="lg:hidden mb-8">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="w-full flex items-center justify-between bg-soft-gray px-4 py-3 rounded-lg text-slate-primary font-medium text-sm"
        >
          <span className="flex items-center gap-2">
            <i className="ri-list-check" /> {t('toc_title')}
          </span>
          {isOpen ? <i className="ri-arrow-up-s-line" /> : <i className="ri-arrow-down-s-line" />}
        </button>
        {isOpen && (
          <div className="bg-white border border-soft-gray rounded-b-lg px-4 py-3 space-y-2">
            {tocItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollTo(item.id)}
                className={`block w-full text-left text-sm py-1.5 transition-colors ${
                  activeId === item.id ? 'text-copper font-semibold' : 'text-slate-primary/60 hover:text-copper'
                }`}
              >
                {t(item.labelKey)}
              </button>
            ))}
          </div>
        )}
      </div>

      {/* Desktop sticky sidebar */}
      <aside className="hidden lg:block w-64 shrink-0">
        <div className="sticky top-24 bg-soft-gray rounded-xl p-5">
          <h3 className="font-manrope font-bold text-slate-primary text-sm mb-4 flex items-center gap-2">
            <i className="ri-list-check text-copper" /> {t('toc_title')}
          </h3>
          <nav className="space-y-2">
            {tocItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollTo(item.id)}
                className={`block w-full text-left text-sm py-1.5 px-2 rounded-md transition-all ${
                  activeId === item.id
                    ? 'text-copper font-semibold bg-copper/10'
                    : 'text-slate-primary/60 hover:text-copper hover:bg-white'
                }`}
              >
                {t(item.labelKey)}
              </button>
            ))}
          </nav>
        </div>
      </aside>
    </>
  );
}